function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1961 0.0391944C10.0666 0.0133024 9.93331 0.0133024 9.80384 0.0391944L0.803777 1.83919C0.336352 1.93268 -0.000108138 2.34309 -0.000108631 2.81977L-0.00012207 16.2559C-0.00012207 16.6975 0.289545 17.0869 0.712529 17.2137L9.42526 19.8276C9.80014 19.94 10.1998 19.94 10.5747 19.8276L19.2874 17.2137C19.7104 17.0869 20 16.6975 20 16.2559V2.81978C20 2.34309 19.6636 1.93268 19.1962 1.83919L10.1961 0.0391944ZM9.76567 4.97066L-3.34949e-05 3.74996V4.99994L9.598 6.91957C9.83171 6.96631 9.99994 7.17152 9.99994 7.40986V16.3766C9.99994 16.6965 10.2961 16.9341 10.6084 16.8647L18.2169 15.174C18.6744 15.0723 19 14.6665 19 14.1978V4.55859C19 4.26058 18.7409 4.02874 18.4448 4.06164L10.2346 4.97387C10.0787 4.99119 9.92131 4.99011 9.76567 4.97066Z",
  fill: "currentColor"
});

var SvgEquity = function SvgEquity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEquity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/equity.a0e1c28d.svg";
export { ForwardRef as ReactComponent };